import React from 'react';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { Order } = Mobi2Go;

class OrderTotal extends React.Component {
    constructor() {
        super();

        this.state = {
            total: Order.getTotal(),
            location_id: Order.getLocation() ? Order.getLocation().id : null,
        };

        Order.bind({
            updateTotal: total => this.setState({ total }),
            updateLocation: location => {
                this.setState({
                    location_id: Order.getLocation()
                        ? Order.getLocation().id
                        : null,
                });
            },
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="m2g-order-item--indented m2g-order-item m2g-order-total">
                {t('total')}
                <span
                    data-total
                    className="m2g-order-item-price m2g-order-total-amount"
                >
                    {t('common:price', { price: this.state.total })}
                </span>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.total')(OrderTotal);
